import React, { Component } from 'react';
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';

import logo from './images/unyted-logo-white.svg';
import styles from './styles.module.scss';

export default class UnauthenticatedHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMobileMenu: false,
      selDropdownOpen: false,
      dropdownOpen: false,
      servicesDropdown: false,
    };

    this.toggleMobile = this.toggleMobile.bind(this);
    this.closeMobile = this.closeMobile.bind(this);
    this.toggleSELDropdown = this.toggleSELDropdown.bind(this);
    this.toggleServicesDropdown = this.toggleServicesDropdown.bind(this);
  }

  toggleMobile() {
    this.setState({ showMobileMenu: !this.state.showMobileMenu });
  }

  closeMobile() {
    this.setState({ showMobileMenu: false });
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  toggleSELDropdown() {
    this.setState({ selDropdownOpen: !this.state.selDropdownOpen });
  }

  toggleServicesDropdown() {
    this.setState({ servicesDropdownOpen: !this.state.servicesDropdownOpen });
  }

  render() {
    const { hideRegistration, simplified, landing } = this.props;

    return (
      <header className="no-pad no-margin">
        <Navbar
          className={`${styles.publicNav} navbar-expand-lg navbar-dark ${landing && styles.landing}`}
        >
          <div className="container py-3">
            <NavbarBrand>
              <LinkContainer to="/">
                <img className={styles.logo} src={logo} alt="Unyted Logo" />
              </LinkContainer>
            </NavbarBrand>
            {!simplified && (
              <NavbarToggler onClick={this.toggleMobile} className="mr-3">
                <span className="sr-only">Toggle Main Navigation</span>
                <span className="navbar-toggler-icon" />
              </NavbarToggler>
            )}
            {!simplified && (
              <Collapse navbar={true} isOpen={this.state.showMobileMenu}>
                <Nav navbar={true} className="mobile ml-auto">
                  {!landing && (
                    <Dropdown
                      nav={true}
                      isOpen={this.state.servicesDropdownOpen}
                      toggle={this.toggleServicesDropdown}
                    >
                      <DropdownToggle
                        className={styles.link}
                        nav={true}
                        caret={true}
                      >
                        Services
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          <LinkContainer to="/online-platform">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>
                                Online Platform for Schools
                              </a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/marketplace">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>
                                Out of School Marketplace
                              </a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                  {!landing && (
                    <Dropdown
                      nav={true}
                      isOpen={this.state.selDropdownOpen}
                      toggle={this.toggleSELDropdown}
                    >
                      <DropdownToggle
                        className={styles.link}
                        nav={true}
                        caret={true}
                      >
                        SEL Power Skills
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          <LinkContainer to="/sel-encyclopedia">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>SEL Encyclopedia</a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/sel-for/educators">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>
                                SEL for Educators
                              </a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/sel-for/parents">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>SEL for Parents</a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                  {!landing && (
                    <Dropdown
                      nav={true}
                      isOpen={this.state.dropdownOpen}
                      toggle={this.toggle}
                    >
                      <DropdownToggle
                        className={styles.link}
                        nav={true}
                        caret={true}
                      >
                        Explore
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>
                          <LinkContainer to="/the-team-method">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>
                                The TEAM Method&trade;
                              </a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/unyted-certified-educators">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>
                                Unyted Certified Educators
                              </a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/case-studies">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>Case Studies</a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/about-unyted">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>About Unyted</a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                        <DropdownItem>
                          <LinkContainer to="/faq">
                            <NavItem className="sel-button">
                              <a onClick={this.closeMobile}>
                                Frequently Asked Questions
                              </a>
                            </NavItem>
                          </LinkContainer>
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}
                  <LinkContainer to="/signup">
                    <NavItem className={hideRegistration ? styles.hide : ''}>
                      <a
                        className={`nav-link ${styles.registerButton}`}
                        onClick={this.closeMobile}
                      >
                        Register
                      </a>
                    </NavItem>
                  </LinkContainer>
                  <LinkContainer to="/login">
                    <NavItem
                      className={`${hideRegistration ? styles.hide : ''} ${styles.loginButton} ${landing && styles.landing}`}
                    >
                      <a className="nav-link" onClick={this.closeMobile}>
                        Sign In
                      </a>
                    </NavItem>
                  </LinkContainer>
                </Nav>
              </Collapse>
            )}
          </div>
        </Navbar>
      </header>
    );
  }
}
